export default "__VITE_ASSET__DThG4F_Y__"